import { Component, Input, SimpleChanges } from '@angular/core';
import { downloadFile, filenameFromPath, openFileInNewTab, safeDecodeURIComponent } from '../../utils/file-viewer.utils';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { getFileViewerTranslations } from '../../constants/file-viewer.translations';

@Component({
  selector: 'app-file-viewer-video',
  imports: [CommonModule],
  templateUrl: './file-viewer-video.component.html',
  styleUrl: './file-viewer-video.component.scss',
})
export class FileViewerVideoComponent {
  @Input() isComponent = false;
  @Input() src: string | null = null;
  @Input() name: string | null = null;
  @Input() languageCode = 'it';

  videoUrl: string | null = null;
  videoTitle = '';

  constructor(private route: ActivatedRoute) {}

  get translations() {
    return getFileViewerTranslations(this.languageCode);
  }

  ngOnInit(): void {
    this._resolveVideoSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] || changes['name']) {
      this._resolveVideoSource();
    }
  }

  download(): void {
    if (!this.videoUrl) {
      return;
    }

    downloadFile(this.videoUrl, this.videoTitle || this.translations.videoFallbackTitle);
  }

  openInNewTab(): void {
    if (!this.videoUrl) {
      return;
    }

    openFileInNewTab(this.videoUrl);
  }

  private _resolveVideoSource(): void {
    const explicitSrc = this.src;
    const explicitName = this.name;
    const rawName = this.route.snapshot.paramMap.get('name');
    const raw = this.route.snapshot.paramMap.get('src');
    const decodedName = rawName ? safeDecodeURIComponent(rawName) : null;
    const decoded = raw ? safeDecodeURIComponent(raw) : null;

    if (explicitSrc) {
      this.videoUrl = explicitSrc;
      this.videoTitle = explicitName || filenameFromPath(explicitSrc);
      return;
    }

    if (decoded) {
      this.videoUrl = decoded;
      this.videoTitle = decodedName || filenameFromPath(decoded);
      return;
    }

    this.videoUrl = null;
    this.videoTitle = '';
  }
}
